import { combineReducers } from '@reduxjs/toolkit';

import {
    activeCheckauto,
    activeParts,
    activePlacement,
    activeRent,
    activeSell,
    activeServices,
} from './active';
import favorite from './common/favorite';
import company from './company';

// checkauto
// import checkauto from './checkauto';

// region services
import placement from './region_services/placement';
import services from './region_services/services';

// vehicleProData
import autoEquipment from './common/vehicle_reducers';
import vehicleProData from './common/vehicle_reducers/vehicle_pro';

// commonData
import commonData from './common/common_reducers';

// AutoFields
import bikeData from './common/bike';
import autoData from './common/car';
import commercialData from './common/commercial';

// parts
import partsData from './common/parts_reducers';
import parts from './region_services/parts';

// sell
import sell from './sell';

// auth
import {
    accountReducer,
    auth,
    forgotPasswordReducer,
    newPasswordReducer,
    newPhoneReducer,
} from './account';

// rent
import rent from './rent';

import { moderate } from './common/textareaModerate';
import { aiDescription } from './common/aiDescriptionSlice';
import { vehicleOptions } from './common/vehicleOptionsSlice';
import { imageUpload } from './common/imageUpload';
import { forgotPasswordModal } from './common/modals/forgotModal';
import { newPasswordModal } from './common/modals/newPasswordModal';
import { newPhoneModal } from './common/modals/newPhoneModal';
import { offerModal } from './common/modals/offerModal';
import { buyTopModal } from './common/modals/buyTopModal';
import { buyPremiumModal } from './common/modals/buyPremiumModal';
import { buyAdvertsModal } from './common/modals/buyAdvertsModal';
import { limitModal } from './common/modals/limitModal';
import { postCreateUpsell } from './common/modals/postCreateUpsell';
import lists from './lists';
import search from './search';
import { sorted } from './search/sort';

// cache
import { cache } from './cache';

import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

const persistConfig = {
    key: 'root',
    storage,
    stateReconciler: autoMergeLevel2,
};

const persistedReducer = (reducer, key) =>
    persistReducer({ ...persistConfig, key }, reducer);

const rootReducer = combineReducers({
    cache,
    activeCheckauto: persistedReducer(activeCheckauto, 'activeCheckauto'),
    activeParts: persistedReducer(activeParts, 'activeParts'),
    activePlacement: persistedReducer(activePlacement, 'activePlacement'),
    activeRent: persistedReducer(activeRent, 'activeRent'),
    activeSell: persistedReducer(activeSell, 'activeSell'),
    activeServices: persistedReducer(activeServices, 'activeServices'),
    lists: persistedReducer(lists, 'lists'),
    forgotPasswordModal,
    newPasswordModal,
    newPhoneModal,
    offerModal,
    buyPremiumModal,
    buyTopModal,
    buyAdvertsModal,
    limitModal,
    postCreateUpsell,
    imageUpload,
    moderate,
    aiDescription,
    vehicleOptions,
    favorite: persistedReducer(favorite, 'favorite'),

    auth: persistedReducer(auth, 'auth'),
    newPassword: newPasswordReducer,
    forgotPassword: forgotPasswordReducer,
    account: persistedReducer(accountReducer, 'account'),
    newPhone: newPhoneReducer,
    company: persistedReducer(company, 'company'),

    autoEquipment: persistedReducer(autoEquipment, 'autoEquipment'),

    autoData,
    bikeData,
    commercialData,

    sell: persistedReducer(sell, 'sell'),
    rent: persistedReducer(rent, 'rent'),

    search,
    sorted,

    commonData: persistedReducer(commonData, 'commonData'),
    partsData: persistedReducer(partsData, 'partsData'),
    vehicleProData: persistedReducer(vehicleProData, 'vehicleProData'),

    // checkauto,

    parts: persistedReducer(parts, 'parts'),
    services: persistedReducer(services, 'services'),
    placement: persistedReducer(placement, 'placement'),
});

export default rootReducer;
